import { useReadContract } from "wagmi";
import { marketplaceAbi } from "@/components/abi";
import { NftMarketPlaceAddress } from "@/components/address";
const useMarketplaceFee = () => {
  return useReadContract({
    address: NftMarketPlaceAddress,
    abi: marketplaceAbi,
    functionName: "marketplaceFee",
    args: [],
  });
};

export default useMarketplaceFee;
